"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ArrowDownCircleOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M23.7 16.2a1 1 0 00-1.5 0L17 21.5V8a1 1 0 10-2 0v13.5l-5.2-5.3a1 1 0 00-1.5 0 1 1 0 000 1.5l6.9 7a1 1 0 00.8.3 1.1 1.1 0 00.8-.3l6.9-7a1 1 0 000-1.5z"/><path d="M4 16a12 12 0 1112 12A12 12 0 014 16m-2 0A14 14 0 1016 2 14 14 0 002 16z"/>';
var ArrowDownCircleOutlineSVG = function ArrowDownCircleOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.ArrowDownCircleOutlineSVG = ArrowDownCircleOutlineSVG;
ArrowDownCircleOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ArrowDownCircleOutlineSVG);
exports.default = _default;